import { useQuery, useMutation } from '@tanstack/react-query'
import { settingsApi } from '../services/settings.service'
import { queryClient } from '@/lib/api/queryClient'
import { qk } from '@/lib/api/queryKeys'
import { DEFAULT_SETTINGS, type ShopSettings } from '../model/types'

export function useSettings() {
  const q = useQuery({
    queryKey: qk.settings.get,
    queryFn: () => settingsApi.get(),
    staleTime: 5 * 60_000,
  })
  // Trả về object settings (hoặc default khi đang load/error) để component luôn render được
  const data: ShopSettings = q.data ?? DEFAULT_SETTINGS
  return { ...q, data }
}

export function useUpdateSettings() {
  return useMutation({
    mutationFn: (patch: Partial<ShopSettings>) => settingsApi.update(patch),
    onSuccess: (updated) => {
      queryClient.setQueryData(qk.settings.get, updated)
    },
  })
}
